// extracted by css-extract-rspack-plugin
export default {"IssueTypeToken":"IssueType-module__IssueTypeToken__Ect_w","hiddenPlaceholder":"IssueType-module__hiddenPlaceholder__Z7sTb"};